'use client';
import { handleHeaderColorScheme, handleNotFoundPage } from '@lib/store/slices/ComponentsSlice';
import useScroll from '@lib/tools/hooks/useScroll';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { useEffect, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function NotFoundPageClient() {
  const { isMobile, isTablet, viewport } = useViewport();

  const dispatch = useDispatch();

  const { scrollY } = useScroll();

  const removeNotFoundCookie = () => {
    document.cookie = 'this_page=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  const setNotFoundCookie = () => {
    document.cookie = 'this_page=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'this_page=404 Not Found';
  };

  useEffect(() => {
    dispatch(handleHeaderColorScheme('multiOnTransparent'));
    dispatch(handleNotFoundPage(true));
    setNotFoundCookie();
    setTimeout(() => removeNotFoundCookie(), 300);
    return function () {
      dispatch(handleHeaderColorScheme(''));
      dispatch(handleNotFoundPage(false));
      removeNotFoundCookie();
    };
  }, []);

  useLayoutEffect(() => {
    if (isMobile || isTablet) {
      dispatch(handleHeaderColorScheme(''));
    }
  }, [scrollY, viewport, dispatch]);

  return <></>;
}
